import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { Stack } from "components/layout/reusableLayouts";

interface LoadingWithoutModalProps {
  open: boolean;
  smallLoading?: boolean;
  curved?: boolean;
  text?: string;
  contained?: boolean;
}

const LoadingWithoutModal: React.FC<LoadingWithoutModalProps> = (props) => {
  const { open, curved, smallLoading, text, contained } = props;

  return (
    <Backdrop
      sx={{
        color: "var(--color-text-inverse)",
        backgroundColor: "var(--color-bg-overlay)",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        borderRadius: curved ? "var(--radius-lg)" : undefined,
        ...(contained && { position: "absolute" }),
      }}
      open={open}
    >
      <Stack gap="var(--space-4)" sx={{ alignItems: "center" }}>
        {text && (
          <Typography variant="h6" sx={{ color: "inherit" }}>
            {text}
          </Typography>
        )}
        <CircularProgress
          color="primary"
          size={smallLoading ? "2rem" : "2.5rem"}
        />
      </Stack>
    </Backdrop>
  );
};

export default LoadingWithoutModal;
